import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22Roboto_Mono%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:%22700%22}],%22variableName%22:%22RobotoMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Roboto Mono', 'Roboto Mono Fallback'",
        fontWeight: 700,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
